import { axiosLasta } from 'config';

export const fetchAudioTypes = async () => {
    const response = await axiosLasta('/monitoring/camera/audio-types');
    const { data } = response;
    return data;
};
export const fetchAudioConfiguredCameras = async () => {
    const response = await axiosLasta('/monitoring/elements/camera/audio-configured');
    const { data } = response;
    return data;
};

export const fetchAiqEventTriggersConfigurationCameras = async () => {
    const response = await axiosLasta('/monitoring/elements/camera/button-configured');
    const { data } = response;

    data.map((el) => {
        el.monitoringObject.title = `${el.monitoringObject.name.trim()} (${el.monitoringObject.objectType.trim()})`;
        return el;
    });

    return data;
};

export const fetchLocationMonitoringObjects = async (locationId, active) => {
    const param = active === undefined ? '' : `?active=${active}`;
    const response = await axiosLasta(`/monitoring/object/${locationId}${param}`);
    const { data } = response;
    return data || [];
};

export const fetchAllMonitoringObjects = async (locationId) => {
    const params = new URLSearchParams();

    if (locationId !== undefined && locationId !== null) {
        params.append('locationId', locationId);
    }

    const response = await axiosLasta(`/monitoring/object?${params.toString()}`);
    const { data } = response;
    return data || [];
};

export const fetchMonitoringObjectCameras = async (monitoringObjectId) => {
    const response = await axiosLasta(`/monitoring/elements/camera/${monitoringObjectId}`);
    const { data } = response;
    return data;
};

export const fetchAudioConfigurationChangeLogs = async (fromDate, toDate) => {
    const response = await axiosLasta(`/v2/monitoring/elements/camera/audio-configured/changelogs?startDate=${fromDate}&endDate=${toDate}`);
    const { data } = response;
    return data || [];
};

export const updateCameraAudioType = async (body) => {
    await axiosLasta.put('/monitoring/elements/camera/audio-type', body);
};

export const updateAiqEventTriggersConfiguration = async (body) => {
    await axiosLasta.put('/monitoring/elements/camera/configure-url', body);
};

export const postAiqEventTriggersConfiguration = async (body) => {
    const response = await axiosLasta.post('/monitoring/elements/camera/generate-url', body);
    return response.data;
};
